<script setup lang="ts">

import { useId } from '#imports';

defineEmits<{ (e: 'onChange', payload: boolean): void }>();
defineProps<{ checked?: boolean;
    disabled?: boolean; label: string; }
>();
const id = ref<string | null>(null);

onMounted(() => {
    id.value = useId();
});

</script>

<template>
  <div :class="{ 'pointer-events-none': disabled }"
       :aria-disabled="disabled"
       class="display-flex"
       v-bind="$attrs"
  >

    <input :id="id ?? undefined"
           type="checkbox"
           class="checkbox"
           aria-label="checkbox"
           :checked="checked"
           @change="(event) => $emit('onChange', (event.target as HTMLInputElement).checked)"
    >
    <label :for="id ?? undefined"
           class="checkbox-label cursor-pointer">
      <span class="sr-only"> {{ label }}</span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.checkbox {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;

  &-label {
    display: inline-block;
    width: 28px;
    height: 28px;
    border: 1px solid var(--border-primary, #686976);
    border-radius: var(--control-300-radius, 2px);
    background: transparent;

    &::before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease;
      opacity: 0;
    }
  }
}

input[type="checkbox"]:checked + .checkbox-label::before {
  opacity: 1;
  background: var(--bg-brand-aviation-primary, #8F75FE);
  background-image: url("../../../assets/images/svg/icon/check-mark.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.sr-only {
  position: absolute;
  clip-path: inset(50%);
  width: 1px;
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
}
</style>
